import {Component, EventEmitter, Input, OnInit, Output, TemplateRef} from '@angular/core';

@Component({
  selector: 'app-data-table-column',
  templateUrl: './data-table-column.component.html',
  styleUrls: ['./data-table-column.component.scss']
})
export class DataTableColumnComponent implements OnInit {

  @Input() template: TemplateRef<any>;
  @Input() alignRight = false;
  @Input() alignCenter = false;
  @Input() index = 0;

  public context: any;

  private _item: any
  private _selected: boolean

  @Output() selectItem = new EventEmitter();

  @Input() set item(item: any) {
    this._item = item;
    this.refreshContext();
  }
  get item(): any {
    return this._item;
  }

  @Input() set selected(value: boolean) {
    this._selected = value;
    this.refreshContext();
  }
  get selected(): boolean {
    return this._selected;
  }

  ngOnInit(): void {
    this.refreshContext();
  }

  refreshContext() {
    this.context = {
      ...this._item,
      item: this._item,
      index: this.index,
      selected: this._selected,
      selectItem: () => this.selectItem.emit()
    };
  }
}
